import { MaterialCommunityIcons } from "@expo/vector-icons";
import { StyleSheet, TouchableOpacity, View, useWindowDimensions, } from "react-native";
import { useTranslation } from "@luna-restaurant/i18n";
import { ThemedText, ThemedTextWithBold, ThemedTitle, useCustomTheme, } from "@luna-restaurant/ui";
export const MealplanHeader = ({ onMonthChange, isEditingAllowed, daysRemaining, formattedMonth, formattedMonthOnly, maxWidth, }) => {
    const { colors, fonts } = useCustomTheme();
    const { t } = useTranslation();
    const { width } = useWindowDimensions();
    const isSmallScreen = width < 1250;
    const rightContainerWidthRatio = 0.45;
    const containerPaddingHorizontal = 40;
    const displayDays = Math.max(0, daysRemaining);
    const deadlineKey = displayDays === 0
        ? "mealPlan.editingDeadlineToday"
        : displayDays === 1
            ? "mealPlan.editingDeadlineOne"
            : "mealPlan.editingDeadlineOther";
    const rightContainerDynamicStyles = {
        maxWidth: maxWidth * rightContainerWidthRatio - containerPaddingHorizontal,
    };
    return (<View style={[
            styles.container,
            { backgroundColor: colors.notification },
            isSmallScreen && styles.containerSmall,
        ]}>
      <View style={[
            styles.headerWrapper,
            isSmallScreen && styles.headerWrapperSmall,
        ]}>
        <View style={[styles.headerContent, { maxWidth }]}>
          <View style={[isSmallScreen && styles.leftContainerSmall]}>
            <ThemedTitle subtitle={t("mealPlan.dateSubtitle")} title={formattedMonth} icon={{
            iconSet: "material-community",
            icon: "calendar-multiselect-outline",
        }} titleTextContainerStyle={styles.titleContainer} contentStyle={isSmallScreen ? styles.contentSmall : undefined} rightButton={<TouchableOpacity onPress={() => onMonthChange("next")}>
                  <MaterialCommunityIcons name="chevron-right" size={24} color={colors.text}/>
                </TouchableOpacity>} leftButton={<TouchableOpacity onPress={() => onMonthChange("prev")}>
                  <MaterialCommunityIcons name="chevron-left" size={24} color={colors.text}/>
                </TouchableOpacity>}/>
          </View>
        </View>
        {isEditingAllowed ? (<View style={[
                styles.rightContainer,
                isSmallScreen && styles.rightContainerSmall,
            ]}>
            <View style={[
                styles.rightContainerInner,
                rightContainerDynamicStyles, // right container is 45% of the width minus the padding
                isSmallScreen && styles.rightContainerInnerSmallScreen,
            ]}>
              <View style={styles.rightContainerHeadline}>
                <MaterialCommunityIcons name="star-circle" size={24} color={colors.border}/>
                <ThemedTextWithBold textContent={t(deadlineKey, {
                days: displayDays,
                month: formattedMonthOnly,
            })} style={[
                styles.editingInfo,
                { color: colors.palette.spinach30 },
            ]} fontDefault={fonts.regular} fontBold={fonts.bold}/>
              </View>
              <ThemedText type="title" style={[
                styles.subline,
                fonts.regular,
                isSmallScreen && styles.sublineSmall,
            ]}>
                {t("mealPlan.subline")}
              </ThemedText>
            </View>
          </View>) : null}
      </View>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        width: "100%",
        height: 138,
    },
    headerWrapper: {
        width: "100%",
        height: "100%",
        flexDirection: "row",
        position: "relative",
        justifyContent: "center",
    },
    headerContent: {
        width: "100%",
        alignSelf: "center",
        justifyContent: "flex-start",
    },
    containerSmall: {
        flexDirection: "column",
        height: "auto",
        minHeight: 138,
    },
    leftContainerSmall: {
        width: "100%",
        justifyContent: "flex-start",
    },
    contentSmall: {
        justifyContent: "center",
    },
    rightContainer: {
        position: "absolute",
        right: 0,
        top: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.3)",
        minWidth: "45%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
    },
    rightContainerInner: {
        width: "100%",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        gap: 16,
        paddingVertical: 32,
        paddingHorizontal: 40,
    },
    rightContainerInnerSmallScreen: {
        maxWidth: "100%",
        alignItems: "center",
    },
    rightContainerSmall: {
        position: "relative",
        width: "100%",
    },
    rightContainerHeadline: {
        flexDirection: "row",
        alignItems: "center",
        gap: 8,
    },
    editingInfo: {
        textAlign: "left",
        fontSize: 20,
        lineHeight: 25,
    },
    subline: {
        fontSize: 16,
        lineHeight: 20.8,
    },
    sublineSmall: {
        textAlign: "center",
    },
    titleContainer: {
        minWidth: 340,
    },
    headerWrapperSmall: {
        justifyContent: "flex-start",
        flexDirection: "column",
    },
});
//# sourceMappingURL=MealplanHeader.js.map